import { render, staticRenderFns } from "./NumberRoller.vue?vue&type=template&id=cab17eb2&scoped=true"
import script from "./NumberRoller.vue?vue&type=script&lang=js"
export * from "./NumberRoller.vue?vue&type=script&lang=js"
import style0 from "./NumberRoller.vue?vue&type=style&index=0&id=cab17eb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab17eb2",
  null
  
)

export default component.exports